import { ICD10Disease } from '@dreryk/egabinet-icd-dictionary-frontend-api';

import { createObjectSchema, createStringSchema } from '@dreryk/react-draft';

export const diagnosisSchema = createObjectSchema<ICD10Disease>({
   code: createStringSchema(),
   name: createStringSchema(),
});
